import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModulePreLoading } from '@app/module-pre-loading';
import { LoginAccessGuard } from '@core/guards/login.guard';
import { UserResolver } from '@core/resolvers/user.resolver';
import { OrganizationResolver } from '@core/resolvers/organization.resolver';
import { NotFoundComponent } from '@modules/shared/not-found/not-found.component';
import { ForbiddenComponent } from '@modules/shared/forbidden/forbidden.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [LoginAccessGuard],
        canActivateChild: [],
        resolve: {
            user: UserResolver,
            organization: OrganizationResolver,
        },
        loadChildren: () => import('@modules/layout/layout.module').then((m) => m.LayoutModule),
    },
    {
        path: 'auth',
        loadChildren: () => import('@modules/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'initiation',
        loadChildren: () => import('@modules/initiation/initiation.module').then(m => m.InitiationModule)
    },
    { path: '404', component: NotFoundComponent },
    { path: '403', component: ForbiddenComponent },
    { path: '**', redirectTo: '/404' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
    useHash: false,
    preloadingStrategy: ModulePreLoading,
    enableTracing: false
})],
    exports: [RouterModule]
})
export class AppRouting {
}
